export const EXCMCASEPROBLEM_SHOW_RESET = 'EXCMCASEPROBLEM_SHOW_RESET'
export const EXCMCASEPROBLEM_SHOW_SET_ERROR = 'EXCMCASEPROBLEM_SHOW_SET_ERROR'
export const EXCMCASEPROBLEM_SHOW_SET_RETRIEVED = 'EXCMCASEPROBLEM_SHOW_SET_RETRIEVED'
export const EXCMCASEPROBLEM_SHOW_TOGGLE_LOADING = 'EXCMCASEPROBLEM_SHOW_TOGGLE_LOADING'
